export const CONSTANTS = {
	servicePrefix: 'service',
	noMatterDelta: 10,
};

export const DASHBOARD_TOGGLER = {
	trend: 'trend',
	absolute: 'absolute',
};

export enum COMMENT_TYPES {
	all = 'all',
	positive = 'positive',
	neutral = 'neutral',
	negative = 'negative',
}

export const PAGE_REQUEST_SIZE = 0;

export const ITEMS_PER_PAGE_SIZE = 12;

export const SURVEY_TRACKING_ITEMS_PER_PAGE_SIZE = 6;

export const MARKS_AVERAGE = {
	all: [1, 2, 3, 4, 5, 6, 7],
	min: [1, 2, 3],
	mid: [4, 5],
	max: [6, 7],
};

export const NONE = 'none';

export const NORANK = 10000;
